import React, { useEffect, useState } from 'react';

function FlashcardOnlySection({
  flashcard,
  flashcardOnlyMessage,
  onFlashcardChange,
  setFlashSectionChoose,
  flashChoose,
}) {
  const [flash, setFlash] = useState(false);
  let timerID1;
  let timerID2;
  useEffect(() => {
    if (
      flashChoose &&
      flashChoose.value &&
      flashChoose.typeChoose === 'Flash'
    ) {
      setFlash(false);
      timerID1 = setTimeout(() => {
        setFlash(true);
        setFlashSectionChoose({ value: false, typeChoose: '' });
      }, 1500);
    }
    return () => {
      clearTimeout(timerID1);
      clearTimeout(timerID2);
    };
  }, []);

  const handleRadioClick = (value) => {
    onFlashcardChange(value);
  };

  return (
    <div className={`profile-privacy ${flash ? 'flash' : ''}`}>
      <div className="profile-privacy-header">
        <div className="label">Choose Flash Cards Question</div>
      </div>
      <div className="profile-privacy-body">
        <div className="radio-group">
          <div className="radio-container">
            {flashcard === 'default' ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() => handleRadioClick('default')}
              >
                radio_button_unchecked
              </i>
            )}
            <div className="radio-label">Default</div>
          </div>
          <div className="radio-container">
            {flashcard === 'noFlashcard' ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() => handleRadioClick('noFlashcard')}
              >
                radio_button_unchecked
              </i>
            )}
            <div className="radio-label">No Flash Cards</div>
          </div>
          <div className="radio-container">
            {flashcard === 'flashcardOnly' ? (
              <i className="material-icons radio-icon">radio_button_checked</i>
            ) : (
              <i
                className="material-icons radio-icon"
                onClick={() => handleRadioClick('flashcardOnly')}
              >
                radio_button_unchecked
              </i>
            )}
            <div className="radio-label">Flash Cards Only</div>
          </div>
        </div>
      </div>
      {flashcardOnlyMessage.text !== '' && (
        <div className={`message-${flashcardOnlyMessage.type}`}>
          {flashcardOnlyMessage.text}
        </div>
      )}
    </div>
  );
}

export default FlashcardOnlySection;
